import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './CollapsedBlock.css';
import { ELEMENTS_IN_ROW } from './constants';
import { useContentHeight } from './hooks';

export interface ICollapsedButtonProps {
  opened: boolean;
  onClick(): void;
}

interface ICollapsedBlockProps {
  Button: React.ComponentType<React.PropsWithChildren<ICollapsedButtonProps>>;
  onChangeOpen(opened: boolean): void;
}

export const CollapsedBlock: React.FC<React.PropsWithChildren<ICollapsedBlockProps>> = ({
  Button,
  children,
  onChangeOpen,
}) => {
  const count = React.Children.count(children);

  const [opened, setOpened] = React.useState(false);

  const { contentRef, animated, height, updateHeight } = useContentHeight(opened);

  const toggle = () => {
    if (onChangeOpen) {
      onChangeOpen(!opened);
    }

    updateHeight(!opened, true);

    // В момент нажатия кнопки она получает фокус, поэтому блок скроллится на позиции где кнопка, а не раскрывается вниз
    // Через ref сделать не получится, потому что кнопка может прийти как props
    if (!opened) {
      (document.activeElement as HTMLButtonElement).blur();
    }

    setOpened(!opened);
  };

  return (
    <div>
      <div
        className={clsx(styles['content'], opened && styles['opened'], animated && styles['animated'])}
        ref={contentRef}
        style={{ maxHeight: `${height}px` }}
      >
        {children}
      </div>
      {count > ELEMENTS_IN_ROW && <Button opened={opened} onClick={toggle} />}
    </div>
  );
};
